import { Checkbox } from "@/components/ui/checkbox";

type Props = {
	id: string;
	checked: boolean;
	name: string;
	label: string;
	handleChange: (id: string, name: string, ...args: unknown[]) => void;
	disabled?: boolean;
	otherProps?: React.HTMLAttributes<HTMLDivElement>;
};

export const CheckboxOption: React.FC<Props> = ({
	id,
	name,
	checked,
	label,
	disabled = false,
	handleChange,
	otherProps,
}) => {
	return (
		<div className="flex items-center space-x-2 w-1/2" {...otherProps}>
			<Checkbox
				id={id}
				name={name}
				aria-label={label}
				checked={checked}
				onCheckedChange={() => handleChange(id, name)}
				className="text-white border-white cursor-pointer"
				disabled={disabled}
			/>
			<label
				htmlFor={id}
				className="text-md min-w-[180px] leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer whitespace-nowrap text-base"
				title={label}
			>
				{label}
			</label>
		</div>
	);
};
